import { render, staticRenderFns } from "./SelectedNotams.vue?vue&type=template&id=32802206&scoped=true&"
import script from "./SelectedNotams.vue?vue&type=script&lang=js&"
export * from "./SelectedNotams.vue?vue&type=script&lang=js&"
import style0 from "./SelectedNotams.vue?vue&type=style&index=0&id=32802206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32802206",
  null
  
)

export default component.exports